<template>
    <div class="d-block">
        <Card :bordered="false">
            <div class="d-flex justify-start">
                <div class="d-block mr-md width-220">
                    <Input clearable v-model="search.name" placeholder="姓名..."/>
                </div>
                <div class="d-block mr-md width-220">
                    <Input clearable v-model="search.phone" placeholder="电话..."/>
                </div>
                <button class="btn btn-icons btn-warning" @click="getUser(1)">
                    <img src="static/icon/search-white@16px.png"/>
                </button>
                <span class="d-flex-item"/>
                <div class="d-block">
                    <button class="btn btn-icons btn-success" @click="onUser({}, '', 1)">
                        <img src="static/icon/plus-white@16px.png">
                    </button>
                    <button class="btn btn-icons btn-danger" @click="">
                        <img src="static/icon/delete-white@16px.png">
                    </button>
                </div>
            </div>
        </Card>

        <br/>

        <Card :bordered="false">
            <p slot="title">用户列表</p>
            <Table :columns="tableColumns" :data="tableData" @on-select="setUser" @on-select-all="setUser" @on-select-cancel="setUser" @on-select-all-cancel="setUser">
                <template slot-scope="{row, index}" slot="sex">
                    <span>{{ $common.sex.find(it => it.value === row.sex).text }}</span>
                </template>
                <template slot-scope="{row, index}" slot="birthday">
                    <span>{{ $moment(row.birthday).format('YYYY年MM月DD日') }}</span>
                </template>                
                <template slot-scope="{row, index}" slot="createTime">
                    <span>{{ $moment(row.createTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                </template>
                <template slot-scope="{row, index}" slot="action">
                    <button class="btn btn-sm btn-icons btn-success" @click="onUser(row, index, 0)">
                        <img src="static/icon/details-white@16px.png"/>
                    </button>
                    <button class="btn btn-sm btn-icons btn-primary" @click="onUser(row, index, 2)">
                        <img src="static/icon/editor-white@16px.png"/>
                    </button>
                    <button class="btn btn-sm btn-icons btn-danger" @click="delUser(row, index, 1)">
                        <img src="static/icon/delete-white@16px.png"/>
                    </button>
                </template>
            </Table>
            <br/>
            <Page :total="total" :current="page" :page-size="count" @on-change="getUser"/>
        </Card>
    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                search: {},

                tableColumns: [
                    {
                        type: 'selection',
                        align: 'center',
                        width: 52,
                    },
                    {
                        title: '姓名',
                        key: 'name',
                        sortable: true,
                    },
                    {
                        title: '性别',
                        slot: 'sex',
                        sortable: true,
                    },
                    {
                        title: '联系电话',
                        key: 'phone',
                    },
                    {
                        title: '出生日期',
                        slot: 'birthday',
                    },
                    // {
                    //     title: '月龄',
                    //     key: 'month',
                    //     sortable: true,
                    // },
                    {
                        title: '创建时间',
                        slot: 'createTime',
                        width: 180,
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center',
                        width: 142,
                    }
                ],
                tableData: [],
                tableSelect: [],
                total: 0,
                page: 1,
                count: 13,
            }
        },
        async beforeDestroy() {
            await this.$bus.off('initChangeUserSuccess');
        },
        async created() {
            await this.getUser(this.page);
        },
        async mounted() {
            await this.$bus.on('initChangeUserSuccess', async (data) => {
                console.log('this.initChangeUserSuccess---------->', data);
                if (!data) return;
                await this.getUser(this.page);
            });
        },
        methods: {
            async getUser(page){
                this.$Spin.show();
                this.page = page;
                let query = '&status=' + (this.search.status || '') + '&name=' + (this.search.name || '') + '&phone=' + (this.search.phone || '');
                let res = await this.$api.getHttp('test/user/list?page=' + this.page + '&pageSize=' + this.count + query);
                this.$Spin.hide();
                console.log('this.getUser---------->', res);
                if (res.data.code !== 0){
                    return await this.$common.alertModel('error', res.data.msg);
                }
                this.tableData = res.data.data.rows;
                this.total = res.data.data.total;
            },
            async setUser(data){
                console.log('this.setUser---------->', data);
                this.tableSelect = [];
                data.forEach(it => this.tableSelect.push(it.id));
            },
            async onUser(data, index, kind){
                if (kind === 0){
                    return this.$router.push({
                        path: '/user/details',
                        query: {
                            uid: data.id,
                        }
                    });
                }
                return await this.$bus.emit('initChangeUser', true, data, kind);
            },
            async delUser(data, kind) {
                if (kind === 0 && this.select.length === 0) {
                    return await this.$common.alertModel('warning', '请至少选择一条数据');
                }
                if (!await this.$common.confirmModel('是否确认删除用户')) return;

                let res = await this.$api.deleteHttp('test/user/batch/delete', kind === 1 ? [data.id] : this.tableSelect);

                if (res.data.code !== 0) {
                    return await this.$common.alertModel('error', res.data.msg);
                }
                this.$Message.success(res.data.msg);
                await this.getUser(page);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/user/index.vue